// The workflow's stored test (draft meta.test, with its revision) as the server pushed it after Pieve prepared one
// (workflow.test.updated).
const setWorkflowTestSaved = ({ workflowId = null, test = null } = {}) => {
  return {
    type: 'uiSetWorkflowTestSaved',
    payload: { workflowId: String(workflowId || '').trim(), test }
  };
};

export default setWorkflowTestSaved;
